import { Button, type ButtonProps } from '@forest/shared/solid'
import { cn } from '@forest/shared'
import { splitProps } from 'solid-js'

/** The design's Plus Button: the shared Button in the Plus colors. */
export function PlusButton(props: ButtonProps) {
  const [local, rest] = splitProps(props, ['class'])
  return (
    <Button
      type="button"
      class={cn(
        // Its 1px border/plus/identity ring, angled for a plan card, is a
        // hair off the CTA's own 106° and too thin to tell apart.
        'gradient-stroke gradient-stroke-plus-identity bg-plus-identity px-4 text-base font-extrabold leading-5 text-[#00524f] active:bg-plus-pressed',
        local.class,
      )}
      {...rest}
    />
  )
}
